import { Card, SecondaryButton } from "components/atoms";
import joinClasses from "helpers/joinClasses";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Register({ onNext = () => {}, show = false }) {
  const [isAwnserd, setIsAwnserd] = useState(false);

  const [errors, setErrors] = useState({
    email: "",
    telephone: "",
  });

  const [touched, setTouched] = useState({
    email: false,
    telephone: false,
  });

  const [user, setUser] = useState({
    firstname: "",
    lastname: "",
    email: "",
    telephone: "",
    home_site: "",
    rules: false,
  });

  const entries = {
    lastname: "entry.645225369",
    firstname: "entry.543072940",
    email: "entry.1276813519",
    telephone: "entry.1758209847",
    home_site: "entry.1760204080",
  };

  const handleClick = (event) => {
    event.preventDefault();
    localStorage.setItem("user", JSON.stringify(user));
    onNext();
  };
  const handleEmailChange = (event) => {
    setUser({ ...user, email: event.target.value });
    setTouched((prev) => ({ ...prev, email: true }));
  };

  const handleTelephoneChange = (event) => {
    setUser({ ...user, telephone: event.target.value });
    setTouched((prev) => ({ ...prev, telephone: true }));
  };

  const validateEmail = (email) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(email)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "L'email n'est pas valide.",
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        email: "",
      }));
      return true;
    }
  };

  const validateTelephone = (telephone) => {
    const phonePattern = /^(?:\+33|0)[1-9](?:\s?\d{2}){4}$/;
    if (!phonePattern.test(telephone)) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "Le numéro de téléphone n'est pas valide.",
      }));
      return false;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        telephone: "",
      }));
      return true;
    }
  };

  useEffect(() => {
    const emailValid = validateEmail(user.email);
    const phoneValid = validateTelephone(user.telephone);
    if (
      user.firstname.length >= 2 &&
      user.lastname.length >= 2 &&
      emailValid &&
      phoneValid &&
      user.home_site.length >= 2 &&
      user.rules
    ) {
      setIsAwnserd(true);
    } else {
      setIsAwnserd(false);
    }
  }, [user]);

  return (
    <div
      className={joinClasses(
        "flex justify-between w-full",
        show ? "block" : "hidden"
      )}
    >
      <div
        className="w-full bg-no-repeat bg-right"
        style={{
          backgroundImage: `url("/assets/icons/welcome-left.png")`,
        }}
      />
      <Card className="mt-16 !mb-14 z-10 relative">
        <h2 className="font-tt-ramillas-trl-bold-italic text-left text-[25px] text-fourth uppercase mt-8 mb-5">
          Informations personnelles
        </h2>
        <div className="flex flex-col md:flex-row md:gap-5">
          <input
            type="text"
            name={entries.lastname}
            onChange={(event) =>
              setUser({ ...user, lastname: event.target.value })
            }
            placeholder="Nom"
            className="w-full border-b text-secondary border-black p-3 mb-5 focus:outline-black focus:border-black font-futura-book text-[18px]"
            required
          />
          <input
            type="text"
            name={entries.firstname}
            onChange={(event) =>
              setUser({ ...user, firstname: event.target.value })
            }
            placeholder="Prénom"
            className="w-full border-b text-secondary border-black p-3 mb-5 focus:outline-black focus:border-black font-futura-book text-[18px]"
            required
          />
        </div>
        <div className="flex flex-col md:flex-row md:gap-5">
          <div className="w-full mb-5">
            <input
              type="email"
              name={entries.email}
              onChange={handleEmailChange}
              placeholder="E-mail"
              className="w-full border-b text-secondary border-black p-3 mb-5 focus:outline-black focus:border-black font-futura-book text-[18px]"
              required
            />
            {touched.email && errors.email && (
              <p className="text-red-800 font-semibold text-[12px]">
                {errors.email}
              </p>
            )}
          </div>
          <div className="w-full mb-5">
            <input
              type="tel"
              name={entries.telephone}
              onChange={handleTelephoneChange}
              placeholder="Téléphone"
              className="w-full border-b text-secondary border-black p-3 mb-5 focus:outline-black focus:border-black font-futura-book text-[18px]"
              required
            />
            {touched.telephone && errors.telephone && (
              <p className="text-red-800 font-semibold text-[12px]">
                {errors.telephone}
              </p>
            )}
          </div>
        </div>
        <div className="w-full mb-5">
          <select
            className="w-full border-0 border-b border-black text-secondary p-3 mb-5 focus:outline-none focus:border-black font-futura-book text-[18px]
            "
            onChange={(event) =>
              setUser({ ...user, home_site: event.target.value })
            }
            defaultValue=""
            name={entries.home_site}
          >
            <option disabled value="">
              Site de rattachement
            </option>
            <option value="GL Haussmann">GL Haussmann</option>
            <option value="GL Annecy">GL Annecy</option>
            <option value="Boutique Toulouse">Boutique Toulouse</option>
            <option value="Boutique Marais">Boutique Marais</option>
            <option value="Boutique Hauteville">Boutique Hauteville</option>
            <option value="Boutique Bac">Boutique Bac</option>
          </select>
        </div>

        <div>
          <input
            type="checkbox"
            name="cgu"
            id="cgu"
            className="mr-2"
            onChange={(event) =>
              setUser({ ...user, rules: event.target.checked })
            }
            required
          />
          <label htmlFor="cgu" className="font-futura-book text-[18px]">
            J'accepte le{" "}
            <Link to="/reglement" className="text-secondary">
              règlement du jeu concours
            </Link>
          </label>
        </div>
        <div className="flex justify-center mt-16">
          {isAwnserd && (
            <SecondaryButton
              onClick={handleClick}
              className={joinClasses(
                !isAwnserd && "!cursor-not-allowed pointer-events-none",
                "!bg-third !absolute !bottom-[-51px] !right-0 !px-16"
              )}
            >
              Continuer {">"}
            </SecondaryButton>
          )}
        </div>
      </Card>
      <div
        className="w-full bg-no-repeat bg-left-bottom mb-20"
        style={{
          backgroundImage: `url("/assets/icons/welcome-right.jpg")`,
        }}
      />
    </div>
  );
}
